var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MeetingType } from '@web/components/Filters/Elements/MeetingType';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { PeriodBarChart } from '@web/components/layout/RechartsItems/PeriodBarChart';
import { rechartsDiagonalStripeFillUrl } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { PLANNED_VS_AD_HOC_MEETING_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter, hasTeamAverageTotals } from '@web/utility/ tooltip/periodComparisonTooltip';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ComparisonPeriod, navigateFromPeriodChartBarClick } from '@web/utility/searchMeetingsNavigation';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var PLANNED_VS_AD_HOC_SERIES_KEYS = ['planned', 'adhoc'];
var TABLES_DATA_PREFIX = 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData';
var teamStripePatternId = function (dataKey) {
    return "".concat(InsightTypeEnum.plannedVSAdHocMeetings, "_").concat(dataKey);
};
var mapPlannedVsAdHocChartData = function (periods, showTeamAverage) {
    return periods.map(function (period) { return (__assign({ period: period.period, previousPeriodLabel: period.previousPeriodLabel, currentPlanned: period.planned, currentAdhoc: period.adhoc, previousPlanned: period.prevPlanned, previousAdhoc: period.prevAdhoc }, (showTeamAverage &&
        period.teamPlanned != null &&
        period.teamAdhoc != null && {
        teamPlanned: period.teamPlanned,
        teamAdhoc: period.teamAdhoc
    }))); });
};
export var PlannedVSAdHocMeetingBreakdown = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _b = trpc.plannedVSAdHocMeetings.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamAverage = Boolean(userId) && hasTeamAverageTotals(data.totals);
    var chartData = mapPlannedVsAdHocChartData(data.periods, showTeamAverage);
    var interval = getInterval(dateFrom, dateTo);
    var plannedLabel = t("".concat(TABLES_DATA_PREFIX, ".").concat(PLANNED_VS_AD_HOC_MEETING_CONFIG.planned.translationKey));
    var adhocLabel = t("".concat(TABLES_DATA_PREFIX, ".").concat(PLANNED_VS_AD_HOC_MEETING_CONFIG.adhoc.translationKey));
    var teamAverageLabel = t('export.teamAverage');
    var tooltipSeriesOrder = showTeamAverage
        ? [
            'previousPlanned',
            'previousAdhoc',
            'currentPlanned',
            'currentAdhoc',
            'teamPlanned',
            'teamAdhoc'
        ]
        : ['previousPlanned', 'previousAdhoc', 'currentPlanned', 'currentAdhoc'];
    var handleBarClick = function (barData, fallbackIndex, stack, meetingType) {
        navigateFromPeriodChartBarClick({
            navigateTo: navigateTo,
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId,
            meetingType: meetingType,
            stack: stack
        });
    };
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.plannedVSAdHocMeetings'), description: t('widgetTitleDescriptions.scheduleAndAttendance.plannedVSAdHocMeetings'), insightType: InsightTypeEnum.plannedVSAdHocMeetings, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.plannedVSAdHocMeetings'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            return [2 /*return*/, ((_a = data.periods) !== null && _a !== void 0 ? _a : []).map(function (period) {
                                    var _a, _b;
                                    var teamRow = userId &&
                                        period.teamPlanned != null &&
                                        period.teamAdhoc != null
                                        ? (_a = {},
                                            _a["".concat(teamAverageLabel, " ").concat(plannedLabel)] = period.teamPlanned,
                                            _a["".concat(teamAverageLabel, " ").concat(adhocLabel)] = period.teamAdhoc,
                                            _a) : {};
                                    return __assign((_b = {}, _b[t('filters.period')] = period.period, _b[plannedLabel] = period.planned, _b[adhocLabel] = period.adhoc, _b), teamRow);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: PLANNED_VS_AD_HOC_SERIES_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsx(PeriodBarChart, { chartData: chartData, dateFrom: dateFrom, dateTo: dateTo, interval: interval, barsPerGroup: showTeamAverage ? 3 : 2, allowDecimals: false, tooltipContent: createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: tooltipSeriesOrder, periodComparisonTooltip: true, seriesLabelFormatter: createPeriodComparisonSeriesLabelFormatter({
                                planned: t('tooltip.metrics.planned'),
                                adhoc: t('tooltip.metrics.adhoc')
                            }), separatorAfterDataKeys: showTeamAverage ? ['currentAdhoc'] : undefined, stripeSwatchColors: showTeamAverage
                                ? {
                                    teamPlanned: PLANNED_VS_AD_HOC_MEETING_CONFIG.planned
                                        .teamChartColor,
                                    teamAdhoc: PLANNED_VS_AD_HOC_MEETING_CONFIG.adhoc.teamChartColor
                                }
                                : undefined }), chartData.length), legend: PLANNED_VS_AD_HOC_SERIES_KEYS.map(function (key) { return (_jsx(LegendItem, { color: PLANNED_VS_AD_HOC_MEETING_CONFIG[key].color, label: t("".concat(TABLES_DATA_PREFIX, ".").concat(PLANNED_VS_AD_HOC_MEETING_CONFIG[key].translationKey)), currentValue: "".concat(data.totals[key].current, " / ").concat(data.totals[key].currentDuration), diffValue: data.totals[key].previous, teamAverage: data.totals[key].teamAverage, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, key)); }), stripePatterns: showTeamAverage
                            ? [
                                {
                                    patternId: teamStripePatternId('teamPlanned'),
                                    chartColor: PLANNED_VS_AD_HOC_MEETING_CONFIG.planned.teamChartColor
                                },
                                {
                                    patternId: teamStripePatternId('teamAdhoc'),
                                    chartColor: PLANNED_VS_AD_HOC_MEETING_CONFIG.adhoc.teamChartColor
                                }
                            ]
                            : undefined, stacks: __spreadArray([
                            {
                                stackId: 'prev',
                                segments: [
                                    {
                                        dataKey: 'previousPlanned',
                                        fill: PLANNED_VS_AD_HOC_MEETING_CONFIG.planned
                                            .prevChartColor,
                                        hide: !isSeriesVisible('planned'),
                                        keyPrefix: 'prev-planned',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Previous, MeetingType.SCHEDULED);
                                        }
                                    },
                                    {
                                        dataKey: 'previousAdhoc',
                                        fill: PLANNED_VS_AD_HOC_MEETING_CONFIG.adhoc.prevChartColor,
                                        hide: !isSeriesVisible('adhoc'),
                                        keyPrefix: 'prev-adhoc',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Previous, MeetingType.NON_SCHEDULED);
                                        }
                                    }
                                ]
                            },
                            {
                                stackId: 'curr',
                                segments: [
                                    {
                                        dataKey: 'currentPlanned',
                                        fill: PLANNED_VS_AD_HOC_MEETING_CONFIG.planned.chartColor,
                                        hide: !isSeriesVisible('planned'),
                                        keyPrefix: 'curr-planned',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Current, MeetingType.SCHEDULED);
                                        }
                                    },
                                    {
                                        dataKey: 'currentAdhoc',
                                        fill: PLANNED_VS_AD_HOC_MEETING_CONFIG.adhoc.chartColor,
                                        hide: !isSeriesVisible('adhoc'),
                                        keyPrefix: 'curr-adhoc',
                                        onClick: function (barData, index) {
                                            return handleBarClick(barData, index, ComparisonPeriod.Current, MeetingType.NON_SCHEDULED);
                                        }
                                    }
                                ]
                            }
                        ], (showTeamAverage
                            ? [
                                {
                                    stackId: 'team',
                                    segments: [
                                        {
                                            dataKey: 'teamPlanned',
                                            fill: rechartsDiagonalStripeFillUrl(teamStripePatternId('teamPlanned')),
                                            hide: !isSeriesVisible('planned'),
                                            keyPrefix: 'team-planned'
                                        },
                                        {
                                            dataKey: 'teamAdhoc',
                                            fill: rechartsDiagonalStripeFillUrl(teamStripePatternId('teamAdhoc')),
                                            hide: !isSeriesVisible('adhoc'),
                                            keyPrefix: 'team-adhoc'
                                        }
                                    ]
                                }
                            ]
                            : []), true) }));
                } }))] })));
};
